import styled, { css } from 'styled-components';
import colors from '../../../../../styles/colors';

const ActivityContentContainer = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 16px;
  padding: 8px 20px;
  margin: 4px 0 16px;
  white-space: pre-wrap;

  ${({ isLastAssignedDateInPast }) => isLastAssignedDateInPast
    && css`
      color: ${colors.base.danger};
      font-weight: bold;
    `}
`;

export {
  ActivityContentContainer,
};
